import { Portal } from '@aviv-estimation-funnel/estimation-data-models/enums';
import { addError } from '@mfe-helpers/datadog';

import { getCookie, isTokenExpired } from './authHelpers';
import { extractClaimsFromAccessToken } from './extractClaimsFromToken';
import { refreshJWT } from './refreshJwt';

export interface AuthResult {
    sub: string;
    avivUserId: string;
    tenant: string;
}

export async function authenticate(portal: Portal): Promise<AuthResult | null> {
    const accessTokenCookieKey = process.env['NX_OAUTH_ACCESS_TOKEN_KEY'] as string;
    const accessToken = getCookie(accessTokenCookieKey);

    if (!accessToken) {
        return null;
    }

    if (isTokenExpired(accessToken)) {
        const refreshTokenUrl = process.env['NX_OAUTH_REFRESH_TOKEN_URL'] as string;

        try {
            await refreshJWT({
                refreshTokenUrl,
                accessTokenCookieKey,
            });
        } catch (error: any) {
            addError(error);
            return null;
        }
    }

    return extractClaimsFromAccessToken(accessTokenCookieKey).claims as AuthResult;
}
